//#region Imports

import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExtraOptions } from '@angular/router';
import { ChangePasswordPayload } from '../../models/payloads/change-password.payload';
import { ForgotPasswordPayload } from '../../models/payloads/forgot-password.payload';
import { GetManyProxy } from '../../models/proxies/base/get-many.proxy';
import { createCrudUrl, CrudRequestParams } from '../../utils/crud-options';
import { environment } from '../../../environments/environment';
import { CreateUserPayload } from '../../models/payloads/create-user.payload';
import { UpdateUserPayload } from '../../models/payloads/update-user.payload';
import { UserProxy } from '../../models/proxies/user.proxy';
import { AsyncResult } from '../../modules/http/models/async-result';
import { HttpService } from '../../modules/http/services/http.service';

//#endregion

@Injectable({
  providedIn: 'root',
})
export class UserInteractor {

  //#region Constructor

  constructor(
    private readonly httpService: HttpService,
  ) { }

  //#endregion

  //#region Methods

  public async getAll(crudOptions?: CrudRequestParams<UserProxy>): Promise<GetManyProxy<UserProxy>> {
    const url = createCrudUrl<UserProxy>(environment.apiKeys.user.base, crudOptions);

    return await this.httpService.get<UserProxy[]>(url);
  }

  public async getMe(): Promise<AsyncResult<UserProxy>> {
    return await this.httpService.get<UserProxy>(environment.apiKeys.user.getMe);
  }

  public async create(payload: CreateUserPayload): Promise<AsyncResult<UserProxy>> {
    const url = environment.apiKeys.user.base;

    return await this.httpService.post<UserProxy>(url, payload);
  }

  public async update(id: number, payload: UpdateUserPayload): Promise<AsyncResult<UserProxy>> {
    const url = environment.apiKeys.user.byId.replace('{userId}', String(id));

    return await this.httpService.put<UserProxy>(url, payload);
  }

  public async delete(id: number, password: string): Promise<AsyncResult<UserProxy>> {
    const url = environment.apiKeys.user.byId.replace('{userId}', String(id));

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        password
      },
    };

    return await this.httpService.delete<UserProxy>(url, options);
  }

  public async sendEmail(email: string): Promise<AsyncResult<ForgotPasswordPayload>> {
    const url = environment.apiKeys.userPassword.sendEmail.replace('{email}', email);

    return await this.httpService.post<ForgotPasswordPayload>(url, {});
  }

  public async resetPassword(payload: ChangePasswordPayload, code: string): Promise<AsyncResult<UserProxy>> {

    const url = environment.apiKeys.userPassword.resetPassword.replace('{code}', code);

    return await this.httpService.post<UserProxy>(url, payload);
  }

  public async changePassword(payload: ChangePasswordPayload): Promise<AsyncResult<UserProxy>> {

    const url = environment.apiKeys.userPassword.changePassword;

    return await this.httpService.put<UserProxy>(url, payload);
  }

  public async verifyAccount(code: string): Promise<AsyncResult<UserProxy>> {
    const url =  environment.apiKeys.user.verify.replace('{code}', code);

    return await this.httpService.get<UserProxy>(url)

  }

  //#endregion
}
